/**
 *
 * @param $timeout {angular.ITimeoutService}
 * @param $mdDialog {$mdDialog}
 * @param $q {angular.IQService}
 * @param DeviceService {DeviceService}
 * @param $rootScope {angular.IRootScopeService}
 * @param $translationService {$translationService}
 * @param $injector {angular.auto.IInjectorService}
 * @constructor
 */
function UtilityService($timeout, $mdDialog, $q, DeviceService, $rootScope, $translationService, $injector) {
    this.$timeout = $timeout;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.deviceService = DeviceService;
    this.$rootScope = $rootScope;
    this.$translationService = $translationService;
    this.$injector = $injector;

}
UtilityService.$inject = ['$timeout', '$mdDialog', '$q', 'DeviceService', '$rootScope', '$translationService', '$injector'];
UtilityService.prototype = {
    /**
     * https://stackoverflow.com/questions/105034/how-to-create-guid-uuid
     */
    createUUID() {
        // http://www.ietf.org/rfc/rfc4122.txt
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";
        return s.join("");

        // return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        //   var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        //   return v.toString(16);
        // });

    },
    hideSplashscreen(){
        // Hide Html splashscreen (iOs, browser)
        if(!$(document.body).hasClass('hide-splash-screen')){
            $(document.body).addClass('hide-splash-screen');
            // Hide Cordova Android splashscreen
            this.$timeout(()=>{ // Delay to browser hide splash-screen completely
                if(navigator['splashscreen']){
                    navigator['splashscreen'].hide();
                }
            },100)
        }
    },
    /**
     * Show date picker
     * @param {string} date
     * @param {MouseEvent} $event
     * @param  minDate {string=}
     * @param options {any=}
     * @returns {angular.IPromise<string>}
     */
    showDatePickerModal(date, $event, minDate, options) {
        if(!options){
            options = {
                hidenClearButton: true
            }
        }
        let local = {
            date: moment(date, 'YYYY-MM-DD'),
            options: options
        };
        if (minDate)
            local.options.minDate = minDate;
        return this.$mdDialog.show({
            controller: DatePickerController,
            controllerAs: 'vm',
            templateUrl: 'js/shared/directives/datepicker/datepicker.html',
            clickOutsideToClose: true,
            escapeToClose: true,
            hasBackdrop: true,
            targetEvent: $event,
            locals: local,
            focusOnOpen: false
        });
    },

    /**
     * Show time picker
     * @param {string} value
     * @param {boolean} isShow59
     * @param {string} headerTitle
     * @param {MouseEvent} $event
     */
    showTimePicker(value, isShow59, headerTitle, $event) {
        function convertToString(value) {
            let strValue;
            if (value < 10)
                strValue = "0" + value;
            else
                strValue = value.toString();
            return strValue;
        }

        function createDataSource() {
            let dataSource = [];
            let hours = [];
            for (let i = 0; i <= 23; i++) {
                hours.push({
                    val: convertToString(i),
                    label: convertToString(i)
                });
            }
            let minutes = [];
            for (let i = 0; i < 59; i = i + 5) {
                minutes.push({
                    val: convertToString(i),
                    label: convertToString(i)
                });
            }
            if (isShow59) {
                minutes.push({
                    val: "59",
                    label: "59"
                });
            }
            //Push minute to minutes if minute don't exist in list
            let pices = value.split(":"), minute = convertToString(parseInt(pices[1]));
            let match = _.findIndex(minutes, function (obj) {
                return obj.val === minute;
            });
            if (match === -1) {
                for (let i = 0; i < minutes.length; i++) {
                    if (parseInt(minute) < parseInt(minutes[i].val)) {
                        minutes.splice(i, 0, {
                            val: minute,
                            label: minute
                        });
                        break;
                    }
                }
            }
            dataSource.push(hours);
            dataSource.push(minutes);
            return dataSource;
        }

        let oArrData = createDataSource.apply(this);
        let oArrComponents = [
            {
                component: 0,
                name: "hours",
                label: "Hours",
                width: "50%",
                textAlign: "center"
            },
            {
                component: 1,
                name: "minutes",
                label: "Minutes",
                width: "50%",
                textAlign: "center"
            }
        ], oArrDataSource = [
            {
                component: 0,
                data: oArrData[0]
            },
            {
                component: 1,
                data: oArrData[1]
            }
        ];
        let apo = null;


        // Hide time-picker if press back-button
        /** @type {angular.IScope} */
        let currentScope = this.$rootScope.$new(true);
        this.deviceService.onGoBackButton(currentScope, () => {
            if (apo) {
                apo._hidePicker();
            }
        });
        return this.$q((resolve)=>{
            $("<input/>").AnyPicker({
                i18n: {
                    headerTitle: headerTitle,
                    setButton: this.$translationService.getTranslation('Set'),
                    clearButton: this.$translationService.getTranslation('Clear'),
                    nowButton: this.$translationService.getTranslation('Now'),
                    cancelButton: this.$translationService.getTranslation('Cancel'),
                    dateSwitch: this.$translationService.getTranslation('Date'),
                    timeSwitch: this.$translationService.getTranslation('Time'),
                },
                mode: "select",
                onInit: function () {
                    apo = this;
                },
                formatOutput: (oArrSelectedValues) => {
                    return moment(oArrSelectedValues.values[0].val + ":" + oArrSelectedValues.values[1].val, "HH:mm").format("HH:mm");
                },
                onSetOutput: (sOutput) => {
                    value = sOutput;
                    resolve(value);
                },
                parseInput: () => {
                    if (!value)
                        return ["00", "00"];
                    let time = value, pices = time.split(":"), hour = convertToString(parseInt(pices[0])),
                        minute = convertToString(parseInt(pices[1]));
                    return [hour, minute];
                },
                showComponentLabel: false,
                components: oArrComponents,
                dataSource: oArrDataSource,
                onBeforeHidePicker: () => {
                    // Destroy currentScope when time-picker is hide
                    currentScope.$destroy();
                }
            });
            apo.showOrHidePicker($($event.target).closest('md-input-container').find("input")[0]);

        });

    },

    /**
     * Add slash if not exists
     * @param source
     * @returns {*|string}
     */
    addSlashIfNotExists(source){
        if (!source) {
            return '/';
        }
        if (source.substr(source.length - 1) !== '/') {
            return source + '/';
        }
        return source;
    },


    /**
     * Show image viewer
     * @param attachment {IAttachment}
     * @param attachments {IAttachment[]}
     * @param $event {MouseEvent}
     */
    showImageViewer(attachment, attachments, $event){
        this.$mdDialog.show({
            controller: 'ImageViewerController',
            templateUrl: 'js/internal/imageviewer/imageviewer.view.html',
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            fullscreen: true,
            locals: {
                attachment: attachment,
                attachments: attachments
            },
            onComplete: function (scope, element) {

                //Add class to fix height of md-dialog
                element.addClass("md-dialog-imageviewer");
                scope.vm.ready();
            }
        });
    },
    
    closeAllDialog(){
        // Close all dialog 
        this.$mdDialog.cancel();

        // Close current urgent dialog
        /** @type {NotificationService} */
        this.$injector.get('NotificationService').closeAllDialogUrgent();

        // Close camera
        /** @type {CameraService} */
        this.$injector.get('CameraService').closeCamera();
    }
}

angular.module('shared').service('UtilityService', UtilityService);


/**
 * Repeat String - Javascript
 * https://stackoverflow.com/questions/202605/repeat-string-javascript
 * @param num{number}
 * @return {string}
 */
String.prototype.repeatString = function( num )
{
    return new Array( num + 1 ).join( this );
}
